module.exports = __webpack_public_path__ + "img/image10.0d5235d3.png";